/**
 * Текст доступа для ученика — общий на все места.
 *
 * ⚠️ ОТДЕЛЬНО ОТ КНОПКИ НАМЕРЕННО. Пока функции лежали рядом с компонентом,
 * линтер справедливо ругался: файл с компонентом должен отдавать наружу только
 * компонент, иначе ломается быстрое обновление при разработке.
 *
 * ⚠️ ОДИН ТЕКСТ НА ВСЕ МЕСТА. Кнопка есть в списке учеников курса, после
 * заведения нового и в выгрузке целого потока. Разойдись формат — ученики
 * получали бы разные сообщения от разных администраторов, и половина не поняла
 * бы, где логин.
 */
export function buildAccessText(
  t: (k: string) => string,
  email: string,
  password: string,
  url: string,
): string {
  return [
    t('accessText.title'),
    t('accessText.login'),
    email,
    '',
    t('accessText.password'),
    password,
    '',
    t('accessText.link'),
    url,
  ].join('\n');
}

/** Адрес входа берём у самой страницы: на другом домене он будет верным сам. */
export function loginURL(): string {
  return `${window.location.origin}/login`;
}
